export default {
	pageTitle: 'Podřízení uživatelé',

	firstName: 'Jméno uživatele',
	surname: 'Příjmení uživatele / Název Partnera',
	sellerIn: 'Získatelské číslo',
	searchForAllSubordinate: 'Včetně nepřímo podřízených',

	tableClientName: 'Jméno',
	tableTasksFirst: 'Úkoly ke splnění',
	tableTasksSecond: 'v termínu / po termínu',
	tableTasksInformations: 'Informace',
	tablePS: 'PS',
	tableSubordinates: 'Podřízení',
	tableKH: 'KH',
	tableUnlockedClients: 'Odemčení klienti',
	tableMarketPlaceLeads: 'Příležitosti',
	tableRaAnalysis: 'Analýzy REDy',
	tableSemafor: 'Semafor',
	tableSettings: 'Nastavení',
	reportButton: 'Report úkolů podřízených',

	// table icon tooltips, different than tableHead text
	policyOverview: 'Přehled pojistných smluv',
	subordinates: 'Podřízení uživatelé',
	contactHistory: 'Kontaktní historie',
	settings: 'Nastavení',
};
